export default {
    data() {
        return {
            MortgageProgramTable: 'conditions',
            LoansOffersTable: 'conditions',
            CardsDocsTable: 'docs',
            insuranceTable: 'nazcorp'
        }
    },
    mounted() {
        if (location.pathname.indexOf('/mortgage/programs/') !== -1) {
            if (document.getElementById('mortgageAnchorConditions')) {
                document.getElementById('mortgageAnchorConditions').addEventListener('click', () => {
                    this.MortgageProgramTable = 'conditions';
                })
            }
            if (document.getElementById('mortgageAnchorInsurance')) {
                document.getElementById('mortgageAnchorInsurance').addEventListener('click', () => {
                    this.MortgageProgramTable = 'insurance';
                })
            }
        }
    }
}
